import { gql } from '@apollo/client';
import { MEETING_BASIC_INFO } from './meeting';
import { EXTERNAL_ACCOUNT_BASIC_DATA } from './externalAccount';

const PROFILE_BASIC_DATA = `
  id
  firstName
  lastName
  fullName
  email
  timeZone
  settings {
    name
    value
  }
  availability {
    dayOfWeek
    startTime
    endTime
  }
  membership {
    teamId
    teamName
    role
  }
  currentTeam {
    id
    name
  }
  externalAccounts {
    ${EXTERNAL_ACCOUNT_BASIC_DATA}
  }
`;

const ME_PROFILE = gql`
  {
    me {
      ${PROFILE_BASIC_DATA}
      upcomingMeetings {
        id
      }
      pendingJobs {
        id
      }
      pastJobs {
        id
      }
    }
  }
`;

export const MANAGED_PROJECTS = gql`
  {
    me {
      id
      managedProjects {
        id
        type
        title
        status
        qualtricsSurvey {
          status
        }
        jobs {
          user {
            id
          }
        }
      }
    }
  }
`;

export const UPCOMING_MEETINGS = gql`
  {
    me {
      id
      upcomingMeetings {
        ${MEETING_BASIC_INFO}
      }
    }
  }
`;

export const PAST_MEETINGS = gql`
  {
    me {
      id
      pastJobs {
        ${MEETING_BASIC_INFO}
      }
    }
  }
`;

export const ALL_MEETINGS = gql`
  {
    me {
      id
      upcomingMeetings {
        ${MEETING_BASIC_INFO}
      }
      pastJobs {
        ${MEETING_BASIC_INFO}
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser ($input: UserInput) {
    updateUser(input: $input) {
      ${PROFILE_BASIC_DATA}
      upcomingMeetings {
        id
      }
      pendingJobs {
        id
      }
      pastJobs {
        id
      }
    }
  }
`;

export const UPDATE_SETTING = gql`
  mutation UpdateSetting ($name: String!, $value: String!) {
    updateSetting (name: $name, value: $value) {
      ${PROFILE_BASIC_DATA}
    }
  }
`;

export const UPDATE_CURRENT_TEAM = gql`
  mutation UpdateCurrentTeam($teamId: ID!) {
    updateCurrentTeam(teamId: $teamId) {
      ${PROFILE_BASIC_DATA}
    }
  }
`;

export const LOGOUT = gql`
  mutation Logout ($id: ID!) {
    logout (id: $id) {
      id
    }
  }
`;

export const USER_BY_EMAIL = gql`
  query UserByEmail($email: String!) {
    userByEmail(email: $email) {
      id
      firstName
      lastName
      fullName
      email
      jobs {
        id
        project {
          id
        }
      }
    }
  }
`;

export default ME_PROFILE;
